import { NgClass } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { ThemeCustomizerService } from 'src/app/components/common/theme-customizer/theme-customizer.service';
import { getDomainName, getLanguages } from 'src/environments/environment';

@Component({
    selector: 'app-navbar',
    standalone: true,
    imports: [RouterLinkActive, NgClass, RouterLink],
    templateUrl: './navbar.component.html',
    styleUrl: './navbar.component.scss'
})
export class NavbarComponent {
    isSticky: boolean = false;
    @HostListener('window:scroll', ['$event'])
    checkScroll() {
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (scrollPosition >= 50) {
            this.isSticky = true;
        } else {
            this.isSticky = false;
        }
    }

    isToggled = false;

    constructor(
        public themeService: ThemeCustomizerService,
        private router: Router
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    ngOnInit(): void { }

    classApplied = false;
    toggleClass() {
        this.classApplied = !this.classApplied;
    }

    classApplied2 = false;
    toggleClass2() {
        this.classApplied2 = !this.classApplied2;
    }

    classApplied3 = false;
    toggleClass3() {
        this.classApplied3 = !this.classApplied3;
    }

    onLanguageChange(lang) {
        if (lang == getLanguages().FA_IR || lang == getLanguages().EN_US) {
            localStorage.setItem("language", lang)
            if (lang == getLanguages().FA_IR) {
                this.redirectTo("fa-IR")
            } else {
                this.redirectTo("en-US")
            }
        }
    }

    redirectTo(uri: string) {
        const baseUrl = getDomainName() // Use the current origin dynamically
        window.location.href = `${baseUrl}/${uri}`;
    }
}
